var map = {
	"./App.vue": [
		"3dfd"
	],
	"./components/backoffice/Loader.vue": [
		"0e19",
		"layout-components-backoffice-Loader-vue"
	],
	"./components/backoffice/Navbar.vue": [
		"887a",
		"layout-components-backoffice-Navbar-vue"
	],
	"./components/backoffice/NavbarAdmin.vue": [
		"0b87",
		"layout-components-backoffice-NavbarAdmin-vue"
	],
	"./components/backoffice/Page.vue": [
		"479a"
	],
	"./components/backoffice/UI/ApiContainer.vue": [
		"ab02"
	],
	"./components/backoffice/UI/Button.vue": [
		"b703"
	],
	"./components/backoffice/UI/Captcha.vue": [
		"f994"
	],
	"./components/backoffice/UI/Chart.vue": [
		"4cbc",
		"layout-components-backoffice-UI-Chart-vue"
	],
	"./components/backoffice/UI/InputBox.vue": [
		"377b"
	],
	"./components/backoffice/UI/NotificationCard.vue": [
		"51aa"
	],
	"./components/backoffice/UI/SimpleTable.vue": [
		"622b"
	],
	"./components/backoffice/UI/SwitchButton.vue": [
		"8cf1"
	],
	"./components/backoffice/UI/Table.vue": [
		"9285"
	],
	"./components/backoffice/UI/countdown.vue": [
		"abc2"
	],
	"./components/main/AccessDenied.vue": [
		"2795"
	],
	"./components/main/BuyCrypto.vue": [
		"6d26"
	],
	"./components/main/DarkModeToggle.vue": [
		"032e",
		"layout-components-main-DarkModeToggle-vue"
	],
	"./components/main/DashboardMenu.vue": [
		"b0c1",
		"layout-components-main-DashboardMenu-vue"
	],
	"./components/main/DashboardMenuContainer.vue": [
		"24fc",
		"layout-components-main-DashboardMenuContainer-vue"
	],
	"./components/main/DashboardMenuLink.vue": [
		"e1639",
		"layout-components-main-DashboardMenuLink-vue"
	],
	"./components/main/DataLoading.vue": [
		"de9e"
	],
	"./components/main/Footer.vue": [
		"cac7",
		"layout-components-main-Footer-vue"
	],
	"./components/main/LiveSupport.vue": [
		"07c6"
	],
	"./components/main/Loader.vue": [
		"8e9a"
	],
	"./components/main/LocaleSwitcher.vue": [
		"111f",
		"layout-components-main-LocaleSwitcher-vue"
	],
	"./components/main/Navbar.vue": [
		"906b",
		"layout-components-main-Navbar-vue"
	],
	"./components/main/NavbarUserMenu.vue": [
		"e657",
		"layout-components-main-NavbarUserMenu-vue"
	],
	"./components/main/NotificationWindow.vue": [
		"764a"
	],
	"./components/main/UI/Button.vue": [
		"f4c0"
	],
	"./components/main/UI/Captcha.vue": [
		"d995"
	],
	"./components/main/UI/CoinsDropInput.vue": [
		"1aaf"
	],
	"./components/main/UI/DropZone.vue": [
		"87c4"
	],
	"./components/main/UI/InputBox.vue": [
		"17ca"
	],
	"./components/main/UI/OnlineTable.vue": [
		"b7a8"
	],
	"./components/main/UI/Page.vue": [
		"3467"
	],
	"./components/main/UI/PageContainer.vue": [
		"55c1"
	],
	"./components/main/UI/PaginationTable.vue": [
		"776e",
		"layout-components-main-UI-PaginationTable-vue"
	],
	"./components/main/UI/SelectBox.vue": [
		"e9a8"
	],
	"./components/main/UI/Table.vue": [
		"644b"
	],
	"./components/main/UI/TwoFactorConfirmation.vue": [
		"9934"
	],
	"./components/main/UI/countdown.vue": [
		"f3f3",
		"layout-components-main-UI-countdown-vue"
	],
	"./components/main/UI/staking.vue": [
		"6407"
	],
	"./layouts/backOffice.vue": [
		"2a18",
		"layout-layouts-backOffice-vue"
	],
	"./layouts/backOfficeAdmin.vue": [
		"8e66",
		"layout-layouts-backOfficeAdmin-vue"
	],
	"./layouts/dashboard.vue": [
		"86e6",
		"layout-components-main-Navbar-vue",
		"layout-layouts-dashboard-vue"
	],
	"./layouts/dashboardSettings.vue": [
		"8716",
		"layout-components-main-Navbar-vue",
		"layout-layouts-dashboardSettings-vue"
	],
	"./layouts/dashboardWallets.vue": [
		"22ce",
		"layout-components-main-Navbar-vue",
		"layout-layouts-dashboardWallets-vue"
	],
	"./layouts/default.vue": [
		"7b3d",
		"layout-components-main-Navbar-vue",
		"layout-layouts-default-vue"
	],
	"./layouts/helpCenter.vue": [
		"1a74",
		"layout-components-main-Navbar-vue",
		"layout-layouts-helpCenter-vue"
	],
	"./layouts/terminal.vue": [
		"f194",
		"layout-components-main-Navbar-vue",
		"layout-layouts-terminal-vue"
	],
	"./views/About.vue": [
		"f820"
	],
	"./views/AccountActivation.vue": [
		"ba96"
	],
	"./views/Auth.vue": [
		"2fef"
	],
	"./views/BackOffice/Admin/Auth.vue": [
		"0a6c"
	],
	"./views/BackOffice/Admin/LiveSupport/Chat.vue": [
		"22cc"
	],
	"./views/BackOffice/Admin/LiveSupport/Main.vue": [
		"89ff"
	],
	"./views/BackOffice/Admin/Logs.vue": [
		"4a3e"
	],
	"./views/BackOffice/Admin/Main.vue": [
		"7559"
	],
	"./views/BackOffice/Admin/Mnemonics/Main.vue": [
		"9439"
	],
	"./views/BackOffice/Admin/Mnemonics/Mnemonic.vue": [
		"05b0"
	],
	"./views/BackOffice/Admin/Payouts.vue": [
		"0e75"
	],
	"./views/BackOffice/Admin/Settings/Cloudflare.vue": [
		"bffd"
	],
	"./views/BackOffice/Admin/Settings/Domain/DomainCustomPages.vue": [
		"03c4"
	],
	"./views/BackOffice/Admin/Settings/Domain/DomainDNS.vue": [
		"e4c0"
	],
	"./views/BackOffice/Admin/Settings/Domain/DomainGeneral.vue": [
		"80a2"
	],
	"./views/BackOffice/Admin/Settings/Domain/DomainPages.vue": [
		"37b0"
	],
	"./views/BackOffice/Admin/Settings/Domain/DomainPromocodes.vue": [
		"f8cc"
	],
	"./views/BackOffice/Admin/Settings/Domain/DomainStaking.vue": [
		"f5ab"
	],
	"./views/BackOffice/Admin/Settings/Domain/DomainTrading.vue": [
		"b876"
	],
	"./views/BackOffice/Admin/Settings/Domain/Main.vue": [
		"9a1a"
	],
	"./views/BackOffice/Admin/Settings/Domains.vue": [
		"0ccb"
	],
	"./views/BackOffice/Admin/Settings/General.vue": [
		"02cb"
	],
	"./views/BackOffice/Admin/Settings/LiveSupport.vue": [
		"69a3",
		"layout-views-BackOffice-Admin-Settings-LiveSupport-vue"
	],
	"./views/BackOffice/Admin/Settings/Main.vue": [
		"50df"
	],
	"./views/BackOffice/Admin/Settings/Security.vue": [
		"326a"
	],
	"./views/BackOffice/Admin/Spammers/Main.vue": [
		"8289"
	],
	"./views/BackOffice/Admin/Spammers/Spammer.vue": [
		"aa41"
	],
	"./views/BackOffice/Admin/Tickets/Main.vue": [
		"45e3"
	],
	"./views/BackOffice/Admin/Tickets/Main_old.vue": [
		"151a",
		"layout-views-BackOffice-Admin-Tickets-Main_old-vue"
	],
	"./views/BackOffice/Admin/Tickets/Ticket.vue": [
		"aea7"
	],
	"./views/BackOffice/Admin/Updates.vue": [
		"7a6c"
	],
	"./views/BackOffice/Admin/Users/Main.vue": [
		"6e72"
	],
	"./views/BackOffice/Admin/Users/User/Main.vue": [
		"3363"
	],
	"./views/BackOffice/Admin/Users/User/UserAddresses.vue": [
		"d386"
	],
	"./views/BackOffice/Admin/Users/User/UserBalance.vue": [
		"5202"
	],
	"./views/BackOffice/Admin/Users/User/UserInfo.vue": [
		"d761"
	],
	"./views/BackOffice/Admin/Users/User/UserLogs.vue": [
		"27c5"
	],
	"./views/BackOffice/Admin/Users/User/UserLogs2.vue": [
		"8a05",
		"layout-views-BackOffice-Admin-Users-User-UserLogs2-vue"
	],
	"./views/BackOffice/Admin/Users/User/UserNotification.vue": [
		"1901"
	],
	"./views/BackOffice/Admin/Users/User/UserOrders.vue": [
		"fc00"
	],
	"./views/BackOffice/Admin/Users/User/UserSessions.vue": [
		"99a3"
	],
	"./views/BackOffice/Admin/Users/User/UserTotal.vue": [
		"7831"
	],
	"./views/BackOffice/Admin/Users/User/UserTransactions.vue": [
		"13ff"
	],
	"./views/BackOffice/Admin/Users/User/UserVerification.vue": [
		"2df1"
	],
	"./views/BackOffice/Admin/index.vue": [
		"ba75"
	],
	"./views/BackOffice/User/Arbitrage.vue": [
		"83a7"
	],
	"./views/BackOffice/User/Auth.vue": [
		"dee8"
	],
	"./views/BackOffice/User/Default.vue": [
		"7563"
	],
	"./views/BackOffice/User/Deposits.vue": [
		"17cd"
	],
	"./views/BackOffice/User/LiveSupport/Chat.vue": [
		"390a"
	],
	"./views/BackOffice/User/LiveSupport/Main.vue": [
		"3b71"
	],
	"./views/BackOffice/User/Logs.vue": [
		"fc44"
	],
	"./views/BackOffice/User/Main.vue": [
		"2325"
	],
	"./views/BackOffice/User/Mnemonics/Main.vue": [
		"dce5"
	],
	"./views/BackOffice/User/Mnemonics/Mnemonic.vue": [
		"7440"
	],
	"./views/BackOffice/User/Payouts.vue": [
		"a063"
	],
	"./views/BackOffice/User/Promocodes.vue": [
		"2bc6"
	],
	"./views/BackOffice/User/Settings/BlacklistIp.vue": [
		"b3ea"
	],
	"./views/BackOffice/User/Settings/Domain/DomainCryptoProviders.vue": [
		"bbea"
	],
	"./views/BackOffice/User/Settings/Domain/DomainCustomPages.vue": [
		"3f66"
	],
	"./views/BackOffice/User/Settings/Domain/DomainDNS.vue": [
		"6398"
	],
	"./views/BackOffice/User/Settings/Domain/DomainGeneral.vue": [
		"c4df"
	],
	"./views/BackOffice/User/Settings/Domain/DomainPages.vue": [
		"9778"
	],
	"./views/BackOffice/User/Settings/Domain/DomainPromocodes.vue": [
		"7ac0"
	],
	"./views/BackOffice/User/Settings/Domain/DomainStaking.vue": [
		"1755"
	],
	"./views/BackOffice/User/Settings/Domain/DomainTrading.vue": [
		"77bf"
	],
	"./views/BackOffice/User/Settings/Domain/Main.vue": [
		"324a"
	],
	"./views/BackOffice/User/Settings/Domains.vue": [
		"2dfc"
	],
	"./views/BackOffice/User/Settings/General.vue": [
		"7d83"
	],
	"./views/BackOffice/User/Settings/LiveSupport.vue": [
		"41b8"
	],
	"./views/BackOffice/User/Settings/Main.vue": [
		"4b06"
	],
	"./views/BackOffice/User/Settings/Notifications.vue": [
		"229a"
	],
	"./views/BackOffice/User/Settings/Security.vue": [
		"9e6c"
	],
	"./views/BackOffice/User/Settings/SmartDeposit.vue": [
		"5b34"
	],
	"./views/BackOffice/User/Settings/SupportTeam.vue": [
		"47bd"
	],
	"./views/BackOffice/User/Statistic.vue": [
		"4816"
	],
	"./views/BackOffice/User/Tickets/Main.vue": [
		"41c8"
	],
	"./views/BackOffice/User/Tickets/Ticket.vue": [
		"1213"
	],
	"./views/BackOffice/User/Updates.vue": [
		"7e2c"
	],
	"./views/BackOffice/User/Users/Main.vue": [
		"f643"
	],
	"./views/BackOffice/User/Users/User/Main.vue": [
		"ed9b"
	],
	"./views/BackOffice/User/Users/User/SmartDeposit.vue": [
		"393c"
	],
	"./views/BackOffice/User/Users/User/UserAddresses.vue": [
		"09d5"
	],
	"./views/BackOffice/User/Users/User/UserBalance.vue": [
		"c2f4"
	],
	"./views/BackOffice/User/Users/User/UserInfo.vue": [
		"4e78"
	],
	"./views/BackOffice/User/Users/User/UserLogs.vue": [
		"0ab5"
	],
	"./views/BackOffice/User/Users/User/UserLogs2.vue": [
		"174a",
		"layout-views-BackOffice-User-Users-User-UserLogs2-vue"
	],
	"./views/BackOffice/User/Users/User/UserNotification.vue": [
		"49e7"
	],
	"./views/BackOffice/User/Users/User/UserOrders.vue": [
		"a979"
	],
	"./views/BackOffice/User/Users/User/UserSessions.vue": [
		"c0d2"
	],
	"./views/BackOffice/User/Users/User/UserTotal.vue": [
		"a830"
	],
	"./views/BackOffice/User/Users/User/UserTransactions.vue": [
		"cfd1"
	],
	"./views/BackOffice/User/Users/User/UserVerification.vue": [
		"ee18"
	],
	"./views/BackOffice/User/Verifications.vue": [
		"5b08"
	],
	"./views/BackOffice/User/index.vue": [
		"2a7b"
	],
	"./views/BuyCrypto.vue": [
		"5c4c"
	],
	"./views/Dashboard/History.vue": [
		"7847"
	],
	"./views/Dashboard/Main/index.vue": [
		"c2eb"
	],
	"./views/Dashboard/Main/template.vue": [
		"7414"
	],
	"./views/Dashboard/Orders.vue": [
		"67e3"
	],
	"./views/Dashboard/Referral.vue": [
		"e4f8"
	],
	"./views/Dashboard/Settings/Menu.vue": [
		"0362"
	],
	"./views/Dashboard/Settings/Security/email.vue": [
		"66a8"
	],
	"./views/Dashboard/Settings/Security/google-authentication.vue": [
		"fac7"
	],
	"./views/Dashboard/Settings/Security/index.vue": [
		"fa57"
	],
	"./views/Dashboard/Settings/Security/login-history.vue": [
		"3b94"
	],
	"./views/Dashboard/Settings/Security/password.vue": [
		"a216"
	],
	"./views/Dashboard/Settings/Security/wallet-connect.vue": [
		"7de4"
	],
	"./views/Dashboard/Settings/Verification/index.vue": [
		"be42"
	],
	"./views/Dashboard/Settings/template.vue": [
		"8e40"
	],
	"./views/Dashboard/Staking.vue": [
		"8c3e"
	],
	"./views/Dashboard/Tickets/Main.vue": [
		"6df6"
	],
	"./views/Dashboard/Tickets/Ticket.vue": [
		"d6bc"
	],
	"./views/Dashboard/Wallets/Deposit/index.vue": [
		"3ad6"
	],
	"./views/Dashboard/Wallets/Deposit/payment.vue": [
		"0ba2",
		"layout-views-Dashboard-Wallets-Deposit-payment-vue"
	],
	"./views/Dashboard/Wallets/Main/index.vue": [
		"d86a"
	],
	"./views/Dashboard/Wallets/Transfer/index.vue": [
		"f64b"
	],
	"./views/Dashboard/Wallets/Withdraw/index.vue": [
		"e13d"
	],
	"./views/Dashboard/Wallets/template.vue": [
		"0b81"
	],
	"./views/Exchange/ExchangeAdvanced.vue": [
		"c216"
	],
	"./views/Exchange/ExchangeIndex.vue": [
		"4ee4"
	],
	"./views/Exchange/ExchangeSimple.vue": [
		"2e64"
	],
	"./views/Exchange/trading-chart.vue": [
		"1da7"
	],
	"./views/Faq.vue": [
		"10c2"
	],
	"./views/Fees.vue": [
		"a8b4"
	],
	"./views/ForgotPassword.vue": [
		"f243"
	],
	"./views/HelpCenter/HelpCenterArticle.vue": [
		"7018",
		"layout-views-HelpCenter-HelpCenterArticle-vue"
	],
	"./views/HelpCenter/index.vue": [
		"e042"
	],
	"./views/Index/IndexSlider.vue": [
		"250e",
		"layout-views-Index-IndexSlider-vue"
	],
	"./views/Index/index.vue": [
		"b30e"
	],
	"./views/Listing.vue": [
		"c3e3"
	],
	"./views/Markets.vue": [
		"bd89"
	],
	"./views/PageNotFound.vue": [
		"a5b5"
	],
	"./views/Privacy.vue": [
		"6f9f"
	],
	"./views/ReferralLink.vue": [
		"9b7d"
	],
	"./views/Registration.vue": [
		"3fd1"
	],
	"./views/Terms.vue": [
		"bd91"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4adc";
module.exports = webpackAsyncContext;